import { ModelValidation } from "@/models/modelvalidation";

export interface IServiceProvider {
    uuid?: string | null;
    businessName?: string | null;
    contactEmail?: string | null;
    nickname?: string | null;
    note?: string | null;
    status?: string;
    demoProvider?: boolean;
    id?: string | null;
}

export class ServiceProvider extends ModelValidation {

    public uuid!: string | null;
    public businessName!: string | null;
    public contactEmail!: string | null;
    public nickname!: string | null;
    public note!: string | null;
    public status!: string;
    public demoProvider!: boolean;
    public id!: string | null;

    constructor(serviceProvider: IServiceProvider | any) {
        super();

        if (!serviceProvider) {
            throw new Error("Cannot construct ServiceProvider from falsey IServiceProvider");
        }

        this.uuid = serviceProvider.uuid || null;
        this.businessName = serviceProvider.businessName || null;
        this.contactEmail = serviceProvider.contactEmail || null;
        this.nickname = serviceProvider.nickname || null;
        this.note = serviceProvider.note || null;
        this.status = serviceProvider.status || 'active';
        this.demoProvider = serviceProvider.demoProvider || false;
        this.id = serviceProvider.id || null;
    }

    public static empty(): ServiceProvider {
        return new ServiceProvider({});
    }

    public toNewServiceProviderDto(): IServiceProvider {
        return {
            businessName: this.businessName,
            contactEmail: this.contactEmail,
            nickname: this.nickname,
            note: this.note,
            demoProvider: this.demoProvider,
            status: this.status
        };
    }

    public toUpdateServiceProviderDto(): IServiceProvider {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewServiceProviderDto();
        result.uuid = this.uuid;
        return result;
    }
}
